import { getToken,axiosInstance } from "../../utils/Api";

export const createOfflineGame = async (formdata) =>{ 
    try {
        const response = await axiosInstance.post("/admin/offline/createOfflineGame",formdata,{
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${getToken()}`,
            }
        });
        return response.data;
      } catch (error) {
        throw error;
      } 
} 
export const updateOfflineGame = async (formdata) =>{ 
    try {
        const response = await axiosInstance.put("/admin/offline/updateOfflineGame",formdata,{
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${getToken()}`,
            }
        });
        return response.data;
      } catch (error) {
        throw error;
      } 
} 
export const getOfflineGameByID = async (gameId) => {
  try {
    const response = await axiosInstance.get(`/admin/offline/getOfflineGameDetails`, {
      params: { id: gameId }, 
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error in get game by id:', error);
    return false;
  }
};
export const deleteGameByID = async (deleteGame) => {
  try {
     const response = await axiosInstance.delete(`/admin/offline/deleteOfflineGame`,{     
            data:{game_id:deleteGame},
            headers: {
                Authorization: `Bearer ${getToken()}`,
            },
      });
      return response.data;
    } catch (error) {
         console.error('Error in delete Game:', error);
        return false;
    }
};